module.exports = __webpack_public_path__ + "img/x6.597beade.jpg";